import React, { Fragment, useMemo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import download from 'downloadjs';

import AboutAuth from '../UI/AboutAuth';
import Backdrop from '../Backdrop/Backdrop';
import Modal from '../Modal/Modal';
import FilesUploadAction from '../FileUploadAction/FilesUploadAction';

import { useStore } from "../../hook-store/store.js";
import { marks } from "../../utils/marks.jsx";

// import { ollamaMcpPdfToText } from "../../utils/ollama/pdf-file.js";
// import { marks } from "../../../utils/marks.jsx";
import "./PdfToText.css";
// import "./PdfToTextResult.css"


export default function PdfToTextFileUpload(props) {
    const { 
      // inputPdfFile,
      // setPdfTextData,
      outputText,
      outputTextFile,
      inputPdfFile,
      uploadApp,
    } = props;

    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    const { isAuth } = store.uiStore;

    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedUploadFile, setSelectedUploadFile] = useState();

    const downloadOutputTextFile = (file) => {
        // console.log(file)
        download(file, file.name, file.type);
      };
    let pdfToTextFileUploadBody;

    if (outputTextFile && inputPdfFile) {
      pdfToTextFileUploadBody = (
        <div>
          <div className='pdfToTextUploadButtons'>
            <button className='btnBase'
              onClick={() => {
                downloadOutputTextFile(outputTextFile);
                // downloadCombinedFile(combinedFile.file);
              }}
            >
              {marks.fileTextOMark}{' '}
              {t('pdfToText21', 'Download text file')}
              {' '}{marks.downloadMark}
            </button>
            <button className='btnBase'
              onClick={() => {
                setShowUploadModal(true);
                setSelectedUploadFile(outputTextFile);
                // createCombinedTextFile(context, question, output);
              }}
            >
              {marks.fileTextOMark}{' '}
              {t('pdfToText22', 'Upload text file')}
              {' '}{marks.uploadMark} 
            </button>
            <button className='btnBase'
              onClick={() => {
                setShowUploadModal(true);
                setSelectedUploadFile(inputPdfFile);
                // createCombinedTextFile(context, question, output);
              }}
            >
              {marks.filePdfOMark}{' '}
              {t('pdfToText23', 'Upload pdf file')}
              {' '}{marks.uploadMark} 
            </button>
          </div>

          {showUploadModal && (
            <div>
              <Backdrop 
                zIndex={'95'}
                onCancel={() => { 
                  setShowUploadModal(false);
                }}
              />
              <Modal
                onClose={() => {
                  setShowUploadModal(false);
                }}
              >
                <div >
                  <div className='voiceFileUploadSection'>
                    <div className='voiceFileUploadTitle'>
                      Upload file to Kura Storage
                    </div>
                  </div>

                  {/* {uploadFile && (
                  <div className='voiceFileUploadSection'>
                      {uploadFile.name}
                    </div>
                  )}  */}

                  
                  {isAuth && (
                    <div className='voiceFileUploadSection'>
                      <FilesUploadAction 
                        uploadFiles={[selectedUploadFile]}
                        uploadApp={uploadApp}
                      />
                    </div>
                  )}
                  {!isAuth && (
                    <div className='voiceFileUploadSection'>
                      <AboutAuth />
                    </div>
                  )}
                </div>
              </Modal>
            </div>
          )}
        </div>
      );
    }

    return (
        <Fragment>
          <div>{pdfToTextFileUploadBody}</div>
        </Fragment>
    );
  };
